'use client'

import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { type VariantProps } from 'class-variance-authority'
import { buttonVariants } from './button-variants'
import { cn } from '@/lib/utils'
import Link from 'next/link'

function Button({
  className,
  variant,
  size,
  asChild = false,
  href,
  isLink,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
    href?: string
    isLink?: boolean
  }) {
  const Comp = asChild ? Slot : 'button'

  if (isLink && href) {
    return (
      <Link
        target='_blank'
        href={href}
        className={cn(
          'bg-primary text-primary-foreground inline-flex h-14 w-full items-center justify-center rounded-full text-lg',
          className,
        )}
      >
        {props.children}
      </Link>
    )
  }

  return (
    <Comp
      data-slot='button'
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
